import React from 'react';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faUserCircle, faPencilAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { colors } from '../../../../config/color';
import { Authenticator_Type, Authenticator_Status, APP_LOCAL_DATE_FORMAT, ACR_VALUES } from '../../../../config/constants';
import ItemGroup from './item-group';

export interface GroupKPIProps {
  deleteAuth: Function;
  deleteGroup: Function;
  arrUSB: any;
  arrPassSMS: any;
  arrKPI: any;
  count: any;
  arrSmartCA: any;
  // userProfile: any;
}

export interface GroupKPIState {
  modalShow: boolean;
}

export default class GroupKPI extends React.Component<GroupKPIProps, GroupKPIState> {
  state: GroupKPIState = {
    modalShow: false
  };

  deleteGroupKPI = () => {
    if (this.props.arrPassSMS.length > 0 || this.props.arrUSB.length > 0 || this.props.arrSmartCA.length > 0) {
      this.props.deleteGroup(Authenticator_Type.PKI);
    } else {
      this.props.deleteGroup(null);
    }
  };

  render() {
    return (
      <div>
        <hr />
        <Row style={{ flex: 1 }}>
          <Col style={{ flex: 0.1, backgroudColor: 'red' }}>
            {/* <FontAwesomeIcon icon={faUserCircle} size="5x" color={colors.iconUser} /> */}
            <img src={require('../../../../images/avatar_icon.png')} alt="" />
          </Col>
          <Col style={{ flex: 0.7 }}>
            <div>
              <h5 className="font-common">Xác thực bằng Sim ký số</h5>
            </div>
          </Col>
          <Col style={{ flex: 0.2 }} className="text-center">
            <Button className="btnDeleteAllGroup" onClick={() => this.deleteGroupKPI()}>
              {/* <Button
              className="btnDeleteAllGroup"
              onClick={() => this.deleteGroupKPI()}
              disabled={this.props.userProfile != null && this.props.userProfile.acrValue == ACR_VALUES.LOA2 ? true : false}
            > */}
              <FontAwesomeIcon icon={faTrashAlt} color="#4D9235" />
            </Button>
          </Col>
        </Row>

        {this.props.arrKPI.map(obj => (
          <ItemGroup
            count={this.props.count}
            key={obj.id}
            auth={obj}
            deleteAuth={this.props.deleteAuth}
            handleActive={null}
            resetPassword={null}
            // userProfile={this.props.userProfile}
          />
        ))}
      </div>
    );
  }
}
